import React, { useCallback, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Grid from "../../components/grid/grid";
import axiosInstance from "../../api/axiosInstance";
import "./favoriten.scss"

const Favoriten = () => {
    const [favorites, setFavorites] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        try {
            const [favoritesRes] = await Promise.all([
                axiosInstance.get('favorites')
            ]);
            setFavorites(favoritesRes.data);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return isLoading ? (<div className="loading" />) : (
        <div className="favoriten">
            <Helmet>
                <title>Favoriten | Weinkeller</title>
            </Helmet>
            <div className="header">
                <div className="container">
                    <h1>Favoriten</h1>
                </div>
            </div>
            <div className="container">
                <Grid
                    wines={favorites}
                    isLoading={isLoading}
                />
            </div>
        </div>
    )
};

export default Favoriten